import React from 'react';
import { Stack, Typography, List } from '@mui/material';
import PageContainer from 'pages/PageContainer';
import { ConsentProcessingLists } from 'shared/constants/legal-pages-constants/consent-processing-constants';
import { HomeLink } from 'components/LegalPagesLinks/HomeLink';
import { MailToLink } from 'components/LegalPagesLinks/MailToLink';
import { CustomListItem } from 'components/List/CustomListItem/CustomListItem';

const ConsentToDataProcessing: React.FunctionComponent = () => (
  <PageContainer showMenu={false}>
    <Stack py={{ xs: 0, md: 4 }} rowGap="64px" width="100%" maxWidth="1200px" mx="auto">
      <Typography variant="h1">Consent to Data Processing</Typography>
      <Stack rowGap="16px">
        <Typography variant="body2">
          {'By using the '}
          <HomeLink />
          {` platform operated by Deb8.TV (“we,” “our,” or “us”), 
          you consent to the collection, use, and processing of your personal data as described in our Privacy Policy.`}
        </Typography>
        <Typography variant="body2" className="no-uppercase">
          This includes:
        </Typography>
        <List className="list-legal-pages">
          {ConsentProcessingLists.map((item, index) => (
            <CustomListItem key={index} {...item} />
          ))}
        </List>
        <Typography variant="body2" className="no-uppercase">
          You have the right to withdraw consent, request deletion of your data, or opt out of
          certain uses as described in the Privacy Policy.
        </Typography>
        <Typography variant="body2" className="no-uppercase">
          If you do not agree with this processing, please discontinue use of the platform.
        </Typography>
        <Typography variant="body2" className="no-uppercase">
          {'For questions or requests regarding data processing, contact us at '}
          <MailToLink />
        </Typography>
      </Stack>
    </Stack>
  </PageContainer>
);

export default ConsentToDataProcessing;
